import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import {
  getComments,
  updateComment
} from '../../services/commentsService';
import CommentsSearch from './components/CommentsSearch';
import CommentsTable from './components/CommentsTable';
const Comments = () => {
  const [comments, setComments] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [render, setRender] = useState(false);
  const [offset, setOffset] = useState((pageNo - 1) * pageSize);
  const [selectedTab, setSelectedTab] = useState('pending');
  const [uniqueAlumCount, setUniqueAlumCount] = useState(0);
  const [fetching, setFetching] = useState(false);
  const [searchFilter, setSearchFilters] = useState({});
  const [csvReport, setCsvReport] = useState({});

  useEffect(() => {
    fetchComments();
  }, [pageNo, pageSize, searchFilter, render]);

  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields();
    setSearchFilters({});
    setOffset(0);
    setPageNo(1);
  };
  const onFinish = (values) => {
    setPageNo(1);
    setSearchFilters(values);
  };

  const renderComments = () => {
    setRender(!render);
  };

  const fetchComments = () => {
    const formatted = {
      ...searchFilter,
      ...(selectedTab !== 'all' && { status: selectedTab })
    };

    if (formatted.startDate)
      formatted.startDate = formatted.startDate.format('YYYY-MM-DD');
    setFetching(false);
    const paginationParams = { paginate: 1, pageNo, pageSize };
    getComments(paginationParams, formatted)
      .then((response) => {
        const data = response.data.data;
        setUniqueAlumCount(data?.uniqueCount);
        setFetching(false);
        setComments(data.paginatedList);
        setTotalCount(data.totalCount);
      })
      .catch((error) => {
        setFetching(false);
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  };

  const onPaginationChange = (data) => {
    setPageNo(data.current);
    setPageSize(data.pageSize);
    setOffset(data.current * data.pageSize - data.pageSize);
  };

  return (
    <div>
      <div>
        <section>
          <CommentsSearch onFinish={onFinish} onReset={onReset} />
        </section>
      </div>
      <div>
        <section>
          <h1>
            Comments that are {selectedTab}: {totalCount}
          </h1>
        </section>
        <br /> <br /> <br />
        <section>
          <CommentsTable
            data={comments}
            setData={setComments}
            onPaginationChange={onPaginationChange}
            current={pageNo}
            totalCount={totalCount}
            fetching={fetching}
            offset={offset}
            fetchComments={renderComments}
            setSelectedTab={setSelectedTab}
          />
        </section>
      </div>
    </div>
  );
};

export default Comments;
